import { ComponentFactoryResolver, Directive, Input, OnChanges, SimpleChanges, ViewContainerRef, OnDestroy } from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FormInputComponent} from '../components/dynamic-form/form-input/form-input.component';
import {FormSelectComponent} from '../components/dynamic-form/form-select/form-select.component';
import {Config} from '../models/config';
import {FormCheckBoxComponent} from '../components/dynamic-form/form-check-box/form-check-box.component';
import {FormTextAreaComponent} from '../components/dynamic-form/form-text-area/form-text-area.component';
import {DataSelectService} from '../services/data-select.service';
import {FormDatePickerComponent} from '../components/dynamic-form/form-date-picker/form-date-picker.component';
import {FormTypeaheadComponent} from '../components/dynamic-form/form-typeahead/form-typeahead.component';
import {FormLinkComponent} from '../components/dynamic-form/form-link/form-link.component';
import { Store } from '@ngrx/store';

import * as fromShared from '../reducers';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import * as _ from 'lodash';
import {FormDateRangePickerComponent} from '../components/dynamic-form/form-date-range-picker/form-date-range-picker.component';
import {FormMultiselectComponent} from '../components/dynamic-form/form-multiselect/form-multiselect.component';

const components = {
  checkBox: FormCheckBoxComponent,
  datePicker: FormDatePickerComponent,
  dateRangePicker: FormDateRangePickerComponent,
  input: FormInputComponent,
  link: FormLinkComponent,
  select: FormSelectComponent,
  multiselect: FormMultiselectComponent,
  textarea: FormTextAreaComponent,
  typeAhead: FormTypeaheadComponent
};

@Directive({
  selector: '[storeverDynamicField]'
})
export class DynamicFieldDirective implements OnChanges, OnDestroy {

  @Input() config: Config;
  @Input() group: FormGroup;
  @Input() structure: string[];
  @Input() isAdd: boolean;
  @Input() isEdit: boolean;
  @Input() isExchange: boolean;
  @Input() orderType: number;
  component;
  // tslint:disable-next-line
  typeAheadResult: any;
  $subs: Subscription[] = []
  constructor(
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef,
    private dataSelect: DataSelectService,
    private store: Store<fromShared.AppState>) {
  }

  ngOnDestroy(): void {
    if (this.$subs && this.$subs.length) {
      this.$subs.forEach(sub => {
        sub.unsubscribe();
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.group && changes.group.currentValue) {
      if (!this.component) {
        const component = components[this.config.type];
        const factory =
                this.resolver.resolveComponentFactory<
                  FormCheckBoxComponent |
                  FormDatePickerComponent |
                  FormInputComponent |
                  FormLinkComponent |
                  FormSelectComponent |
                  FormMultiselectComponent |
                  FormTextAreaComponent |
                  FormDateRangePickerComponent |
                  FormTypeaheadComponent>(component);
        this.component = this.container.createComponent(factory);
      }
      this.component.instance.config = this.config;
      this.component.instance.group = this.group;
      this.component.instance.structure = this.structure;
      this.component.instance.isEdit = this.isEdit;
      this.component.instance.isAdd = this.isAdd;
      this.component.instance.isExchange = this.isExchange;
      this.component.instance.orderType = this.orderType;
      if (this.config.data) {
        if (this.config.options.typeaheadAction) {
          // tslint:disable-next-line
          let action:any = _.clone(this.config.options.typeaheadAction);
          action.payload = { typeaheadQuery: '', $length: this.config.options.typeaheadOptionsLimit };
          this.store.dispatch(action);

          const sub = this.component.instance.typeaheadQueryChange
            .pipe(debounceTime(this.config.options.typeaheadDebounce), distinctUntilChanged())
            .subscribe(data => {
              // tslint:disable-next-line
              let newAction:any = _.clone(this.config.options.typeaheadAction);
              newAction.payload = { typeaheadQuery: data, $length: this.config.options.typeaheadOptionsLimit, $orderBy: null };
              this.store.dispatch(newAction);
          });
          this.$subs.push(sub);
        }

        if (this.config.options.typeaheadAsync) {
          this.component.instance.datas = this.dataSelect.getDataSelect(this.config.data);
        } else {
          const sub = this.dataSelect.getDataSelect(this.config.data).subscribe(datas => this.component.instance.datas = datas);
          this.$subs.push(sub);
        }
      }
    }
    // TODO: why not used for other params context ? still this useful ?
    if (changes.isEdit && !changes.isEdit.firstChange) {
      if (this.component) {
        this.component.instance.isEdit = changes.isEdit.currentValue;
      }
    }
  }
}
